import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from 'styled-components';

import ServiceDropdown from './ServiceDropdown';
import ValueField, { Value } from './ValueField';
import Checkbox from './Checkbox';

const ServiceDescription = styled.div`
    margin: 1rem 0 !important;
`;

const SelectionRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

class ApplicationItem extends React.Component {
    state = {
        serviceDropdownOpened: false,
        selectedService: null,
        value: 0,
        amount: 0,
        childServices: [],
        values: {},
    };

    render() {
        const {
            selectedService,
            value,
            values,
            amount,
            serviceDropdownOpened,
        } = this.state;
        const { services, showRemoveButton, onRemove, item, intl } = this.props;

        return (
            <div>
                <SelectionRow>
                    <ServiceDropdown
                        items={services.filter((item) => item.primary)}
                        opened={serviceDropdownOpened}
                        selectedItem={selectedService}
                        onClick={this.handleServiceDropdownClick}
                        onSelect={this.handleSelectService}
                    />
                    {showRemoveButton && (
                        <button
                            className="delete"
                            onClick={() => onRemove(item)}
                        />
                    )}
                </SelectionRow>
                {selectedService && (
                    <div>
                        <ServiceDescription>
                            <div className="notification">
                                <FormattedMessage
                                    id={`exhibitApplication.services.${
                                        selectedService.name
                                    }.description`}
                                    tagName="p"
                                />
                            </div>
                        </ServiceDescription>
                        {selectedService.values ? (
                            <div style={{ display: 'flex' }}>
                                <div style={{ flex: 1 }}>
                                    {Object.keys(selectedService.values).map(
                                        (key) => (
                                            <ValueField
                                                key={key}
                                                title={intl.formatMessage({
                                                    id: `exhibitApplication.services.${
                                                        selectedService.name
                                                    }.${key}`,
                                                })}
                                                value={values[key]}
                                                unit={
                                                    selectedService.values[key]
                                                        .unit
                                                }
                                                onChange={this.handleValuesChange(
                                                    key
                                                )}
                                            />
                                        )
                                    )}
                                </div>
                                <Value style={{ alignSelf: 'center' }}>
                                    €{amount}
                                </Value>
                            </div>
                        ) : (
                            <ValueField
                                value={value}
                                onChange={this.handleValueChange}
                                unit={selectedService.unit}
                                price={selectedService.price}
                                amount={amount}
                            />
                        )}
                        {selectedService.services &&
                            selectedService.services.map(
                                this.renderChildService
                            )}
                    </div>
                )}
            </div>
        );
    }

    initChildServices = (service) => {
        if (!service.services) {
            return [];
        }
        const childServices = this.props.services
            .filter(
                (item) => service.services.filter((i) => i === item.name).length
            )
            .map((item) => ({
                ...item,
                value: item.minValue,
                amount: item.minValue * item.price,
                selected: false,
            }));
        return childServices;
    };

    renderChildService = (childServiceName) => {
        const childService = this.state.childServices.find(
            (item) => (item.name = childServiceName)
        );
        const { selected, value, amount, unit, price } = childService;

        return (
            <div key={childServiceName} style={{ marginTop: '1rem' }}>
                <Checkbox
                    selected={selected}
                    onChange={() =>
                        this.handleChildServiceSelectChange(childService)
                    }
                    messageId={`exhibitApplication.services.${childServiceName}.title`}
                    style={{ marginBottom: selected ? '0.5rem' : 0 }}
                />
                {selected && (
                    <ValueField
                        value={value}
                        onChange={(event) =>
                            this.handleChildServiceValueChange(
                                event,
                                childService
                            )
                        }
                        unit={unit}
                        price={price}
                        amount={amount}
                    />
                )}
            </div>
        );
    };

    handleServiceDropdownClick = () => {
        this.setState({
            serviceDropdownOpened: !this.state.serviceDropdownOpened,
        });
    };

    handleSelectService = (event) => {
        const selectedService = this.props.services.find(
            (item) => item.name === event.currentTarget.dataset.name
        );
        if (
            this.state.selectedService &&
            selectedService.name === this.state.selectedService.name
        ) {
            this.setState({
                serviceDropdownOpened: false,
            });
            return;
        }
        const values =
            selectedService.values &&
            Object.keys(selectedService.values).reduce(
                (prev, cur) => ({
                    ...prev,
                    [cur]: selectedService.values[cur].minValue,
                }),
                {}
            );
        this.setState(
            {
                selectedService,
                value: selectedService.minValue,
                values,
                amount: values
                    ? this.calculateAmount(selectedService.price, values)
                    : selectedService.price * selectedService.minValue,
                serviceDropdownOpened: false,
                childServices: this.initChildServices(selectedService),
            },
            this.onChange
        );
    };

    handleValueChange = (event) => {
        const value = Number(event.currentTarget.value);
        const { selectedService } = this.state;
        const newValue =
            value < selectedService.minValue ? selectedService.minValue : value;
        this.setState(
            {
                value: newValue,
                amount: selectedService.price * newValue,
                childServices: this.recalculateChildServices(newValue),
            },
            this.onChange
        );
    };

    calculateAmount = (price, values) =>
        this.valueFromValues(values) / 9 * price;

    valueFromValues = (values) =>
        Object.keys(values).reduce((prev, cur) => prev * values[cur], 1);

    handleValuesChange = (name) => (event) => {
        const newValue = Number(event.currentTarget.value);
        const { selectedService } = this.state;

        const values = { ...this.state.values, [name]: newValue };
        const value = this.valueFromValues(values);
        const amount = this.calculateAmount(selectedService.price, values);
        this.setState(
            {
                values,
                value,
                amount,
            },
            this.onChange
        );
    };

    handleChildServiceSelectChange = (service) => {
        const { childServices } = this.state;
        this.setState(
            {
                childServices: childServices.map(
                    (item) =>
                        item.name === service.name
                            ? { ...item, selected: !service.selected }
                            : item
                ),
            },
            this.onChange
        );
    };

    handleChildServiceValueChange = (event, service) => {
        const { childServices, value: applicationValue } = this.state;
        const value = Number(event.currentTarget.value);
        const newValue = this.getChildServiceValue(
            value,
            applicationValue,
            service
        );
        this.setState(
            {
                childServices: childServices.map(
                    (item) =>
                        item.name === service.name
                            ? {
                                  ...item,
                                  value: newValue,
                                  amount: newValue * service.price,
                              }
                            : item
                ),
            },
            this.onChange
        );
    };

    getChildServiceValue = (value, applicationValue, service) => {
        return service.minValue && value < service.minValue
            ? service.minValue
            : service.maxValue && value > applicationValue
                ? applicationValue
                : value;
    };

    recalculateChildServices = (applicationValue) => {
        return this.state.childServices.map((service) => {
            if (!service.selected && !service.recalculate) {
                return service;
            }
            const newValue = this.getChildServiceValue(
                service.value,
                applicationValue,
                service
            );
            return {
                ...service,
                value: newValue,
                amount: newValue * service.price,
            };
        });
    };

    onChange = () => {
        const { selectedService, childServices, value, amount } = this.state;
        this.props.onChange(this.props.item, {
            name: selectedService.name,
            price: selectedService.price,
            unit: selectedService.unit,
            value,
            amount,
            childServices: childServices.filter((item) => item.selected),
        });
    };
}

export default injectIntl(ApplicationItem);



// WEBPACK FOOTER //
// ./src/components/ContactForm/components/ApplicationItem.js